import { render, staticRenderFns } from "./HKLButtonModal.vue?vue&type=template&id=3f6975b8&"
import script from "./HKLButtonModal.vue?vue&type=script&lang=js&"
export * from "./HKLButtonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f6975b8')) {
      api.createRecord('3f6975b8', component.options)
    } else {
      api.reload('3f6975b8', component.options)
    }
    module.hot.accept("./HKLButtonModal.vue?vue&type=template&id=3f6975b8&", function () {
      api.rerender('3f6975b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Modal/HKLButtonModal.vue"
export default component.exports